(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.RuppOrdersLicensesHandler = (function(superClass) {
    extend(RuppOrdersLicensesHandler, superClass);

    function RuppOrdersLicensesHandler() {
      return RuppOrdersLicensesHandler.__super__.constructor.apply(this, arguments);
    }

    RuppOrdersLicensesHandler.prototype.init = function() {
      this.layoutUrl = 'backend/grower/rupp-orders/load-layout-licenses';
      this.refreshNavHandler = false;
      this.draggable = true;
      this.destroyOnSave = true;
      this.saveUrl = 'backend/grower/rupp-orders/save-licenses';
      return this.createDialog();
    };

    RuppOrdersLicensesHandler.prototype.afterLoadLayout = function() {
      this.dialog.find('.save-btn').bind('click', (function(_this) {
        return function() {
          return _this.save('Saving License Numbers');
        };
      })(this));
      return this.openDialog();
    };

    RuppOrdersLicensesHandler.prototype.getPostData = function() {
      var cur, data, elem, i, id, len, num, ref;
      data = {};
      data['users_id'] = $('input[name="hdn_users_id"]').val();
      data['licenses'] = [];
      ref = $('input[name="lisc_current"]');
      for (i = 0, len = ref.length; i < len; i++) {
        elem = ref[i];
        id = $(elem).val();
        cur = $(elem).is(':checked');
        num = $(elem).parent().prev().find('input').val();
        data['licenses'].push({
          id: id,
          cur: cur,
          num: num
        });
      }
      return JSON.stringify(data);
    };

    return RuppOrdersLicensesHandler;

  })(DialogHandler);

}).call(this);
